// extracted by mini-css-extract-plugin
export var headerCell = "_3s-1";
export var loadingSpinnerContainer = "_3s-4";
export var rowWrapper = "_3s-3";
export var standaloneTable = "_3s-5";
export var table = "_3s-0";
export var white = "_3s-2";